import React from "react";
import styled from "styled-components";
import ContentLoader from "react-content-loader";
import { LabeledIconButton } from "@sonder/ui/source/styled/fragments/LabeledIconButton";

const StyledAssigneePickerLoader = styled(ContentLoader)`
  height: 38px;
  width: 200px;
`;

const StyledAssigneePickerLoaderButton = styled(LabeledIconButton)`
  > svg {
    width: 200px;
  }
`;

interface AssigneePickerLoaderProps {
  className?: string;
}

export const AssigneePickerLoader = ({
  className,
}: AssigneePickerLoaderProps) => (
  <StyledAssigneePickerLoaderButton disabled className={className}>
    <StyledAssigneePickerLoader height={38} width={200}>
      <path d="m131,22l-90,0l0,11l90,0l0,-11z" fill="black" />
      <path d="m94,5l-53,0l0,11l53,0l0,-11z" fill="black" />
      <path
        d="m16,34c8.2843,0 15,-6.716 15,-15c0,-8.284 -6.7157,-15 -15,-15c-8.2843,0 -15,6.716 -15,15c0,8.284 6.7157,15 15,15z"
        fill="black"
      />
    </StyledAssigneePickerLoader>
  </StyledAssigneePickerLoaderButton>
);
